import { page_text_es } from '../lng/es.js'
import { page_text_ca } from '../lng/ca.js'
import { getServerConfig } from './apiResolver.js'
import { migrated_functions } from '../config/app.json'
import { repo } from '../repository/repo.js'
import { buildServiceTranslationsMap } from '../config/services.js'

// Export language objects for use in other modules
export { page_text_es, page_text_ca }

// Keep window references for backwards compatibility
window['page_text_es'] = page_text_es
window['page_text_ca'] = page_text_ca

const farmaval_version = '13.02'
const page_vars = getUrlVars()

window['page_vars'] = page_vars

if (page_vars['session']) localStorage.farmaval_session = page_vars['session']

export let page_lng = 'es'
if (localStorage.getItem('farmaval_lng') !== null)
    page_lng = localStorage['farmaval_lng']

const serverConfig = getServerConfig()

export const server_url = serverConfig.server_base + 'functions.php'
export const old_server_url = serverConfig.old_server_base + 'code.php'
export const server_base = serverConfig.server_base
export const old_server_base = serverConfig.old_server_base
export const assets_base_url = serverConfig.assets_base_url

// Create a map of language objects
const languageMap = {
    es: page_text_es,
    ca: page_text_ca,
}

export let page_text = languageMap[page_lng] || languageMap.es

function getUrlVars() {
    var vars = {}
    var parts = window.location.href.replace(
        /[?&#]+([^=&#]+)=([^&#]*)/gi,
        function (m, key, value) {
            vars[key] = value
        }
    )
    return vars
}

export function translate_page(lng, update = true) {
    if (update) {
        localStorage['farmaval_lng'] = lng
        page_lng = lng
    }

    // Get language object directly from map
    const currentPageText = languageMap[lng] || languageMap.es

    if (!currentPageText) {
        console.error(`Language ${lng} not found. Using Spanish as fallback.`)
        return
    }

    page_text = currentPageText

    document.querySelectorAll('[aria-lng]').forEach((el) => {
        const textKey = el.getAttribute('aria-lng')
        if (currentPageText[textKey]) {
            el.innerHTML = currentPageText[textKey]
        }
    })

    document.querySelectorAll('[aria-holder]').forEach((el) => {
        const textKey = el.getAttribute('aria-holder')
        if (currentPageText[textKey]) {
            el.setAttribute('placeholder', currentPageText[textKey])
        }
    })

    document.querySelectorAll('[aria-href]').forEach((el) => {
        const textKey = el.getAttribute('aria-href')
        if (currentPageText[textKey]) {
            el.setAttribute('href', currentPageText[textKey])
        }
    })

    document.querySelectorAll('.lng').forEach((element) => {
        element.style.display = 'none'
    })
    document.querySelectorAll('.lng_' + lng).forEach((element) => {
        element.style.display = 'inherit'
    })

    // Apply direct translations to services
    translateServices(lng)
}

export function translateServices(language) {
    const texts = languageMap[language] || languageMap.es

    // Mapa derivado del registry único (src/config/services.js).
    // No editar aquí — para añadir un servicio, editar SERVICES en services.js.
    const serviceTranslations = buildServiceTranslationsMap()

    Object.entries(serviceTranslations).forEach(
        ([serviceId, [nameKey, descKey]]) => {
            const serviceElement = document.getElementById(serviceId)
            if (!serviceElement) return

            const titleEl = serviceElement.querySelector('.service_title')
            const subtitleEl = serviceElement.querySelector('.service_subtitle')

            if (titleEl && texts[nameKey]) {
                titleEl.textContent = texts[nameKey]
            }
            if (subtitleEl && texts[descKey]) {
                subtitleEl.textContent = texts[descKey]
            }
        }
    )

    // Translate other service-related elements with aria-lng
    const noactiveTag = document.querySelectorAll('.noactive_tag')
    noactiveTag.forEach((el) => {
        if (texts['settings_lbl_noactive']) {
            el.textContent = texts['settings_lbl_noactive']
        }
    })

    // Translate probio links
    const probioVideo = document.querySelector('[aria-lng="probio_video"]')
    const probioMore = document.querySelector('[aria-lng="probio_more"]')
    if (probioVideo && texts['probio_video']) {
        probioVideo.textContent = texts['probio_video']
    }
    if (probioMore && texts['probio_more']) {
        probioMore.textContent = texts['probio_more']
    }
}

export function set_version() {
    document.querySelectorAll('.farmaval_version').forEach((el) => {
        el.innerHTML = farmaval_version
    })
}

export function set_enter() {
    document.querySelectorAll('[aria-enter]').forEach((el) => {
        el.addEventListener('keyup', (e) => {
            if (e.keyCode === 13) {
                e.preventDefault()
                document.getElementById(el.getAttribute('aria-enter')).click()
            }
        })
    })
}

export async function server_function(
    func,
    params,
    ret = null,
    session = true
) {
    let json
    try {
        // Funciones migradas a la API de laravel en server v2
        // Se configuran en src/config/app.json migrate_functions
        const migrated_function = migrated_functions[func] ?? false
        if (migrated_function) {
            const method = migrated_function.method.toLowerCase()
            const url = migrated_function.url
            const { data } = await repo[method](url, params)
            json = data
        } else {
            if (func) params.function = func
            if (session && localStorage.getItem('farmavel_token'))
                params.session = localStorage.getItem('farmavel_token')

            const res = await fetch(server_url, {
                method: 'post',
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('farmavel_token')}`,
                },
                body: JSON.stringify(params),
            })
            json = await res.json()
            if (!json) throw new Error('server_error')
        }
    } catch (e) {
        if (!ret) return false
        ret(false)
        return
    }
    if (!ret || typeof ret !== 'function') return json

    return ret(json)
}

export async function old_server_function(params, session = true) {
    let json
    try {
        if (session && localStorage.getItem('farmavel_token'))
            params.session = localStorage.getItem('farmavel_token')

        const res = await fetch(old_server_url, {
            method: 'post',
            mode: 'cors',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(params),
        })
        json = await res.json()
        if (!json) throw new Error('server_error')
        return json
    } catch (e) {
        return { result: 'ko', type: 'server_error' }
    }
}
